import { useLocation, useNavigate } from 'react-router-dom';

import { Button } from '@components/button';
import { IconAIMagic } from '@components/icons/ai-magic';
import { hideSidebar } from '@components/sidebar';
import { useScopedTranslate } from '@locale/translate';

import { useFeature } from 'ui/hooks';
import { useReviewPanelStore } from 'ui/journey-builder/review/use-review-panel-store';

const BUILDER_SECTION = 'journey';

export const ReviewJourneyButton = () => {
  const { t } = useScopedTranslate(locale);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const openReviewPanel = useReviewPanelStore((state) => state.open);
  const closeReviewPanel = useReviewPanelStore((state) => state.close);
  const { isEnabled: hasReviewFeature } = useFeature('FEATURE_JOURNEY_REVIEW');

  if (!hasReviewFeature) {
    return null;
  }

  const handleReviewClick = () => {
    // Read before hiding: a sidebar opened from a finding card hands the space
    // back on close, so hideSidebar can open the panel — and deciding after that
    // would close the panel the user just asked for.
    const wasOpen = useReviewPanelStore.getState().isOpen;

    // The review panel and an action sidebar both occupy the right side — close
    // any open action sidebar so they don't overlap.
    hideSidebar();

    // This button renders on every tab but the panel is only mounted by the
    // builder, so elsewhere navigate and open rather than deciding from a store
    // nothing is listening to.
    if (!pathname.endsWith(`/${BUILDER_SECTION}`)) {
      navigate(`../${BUILDER_SECTION}`, { relative: 'path' });
      openReviewPanel();
      return;
    }

    if (wasOpen) {
      closeReviewPanel();
      return;
    }
    openReviewPanel();
  };

  return (
    <Button
      variant="ai-gradient"
      text={t('reviewMyJourney')}
      iconLeft={<IconAIMagic color="aiGradientTeal100" />}
      onClick={handleReviewClick}
      dataTestid="review-journey-btn"
    />
  );
};

const locale = {
  en: {
    reviewMyJourney: 'Review my journey',
  },
};
